// -- other --
import {useState,useEffect} from "react";
import {Link} from 'react-router-dom'
import ImageWithBasePath from '../../core/img'
import {all_routes} from '../router/all_routes';
// -- biz9  --
import {UrlQuery} from "biz9-react-utility";
import {Log,Response_Logic,DateTime,Obj} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Data_Logic} from "biz9-data-app";
import {Config,Message,Title} from "../../constant";
import {App,Field_Logic,Image,Toast_Message,Storage} from "../../project";
import SubValue from "../subValue";
import {Portal_Type,Portal_Field,Portal_Table,Portal_Stat,Portal_Page,Sub_Value_Logic,Portal_Url,Portal_Value_Type,Portal_Remote_Page,Portal_Remote_Data,Sub_Value_Type} from "biz9-portal-app";

const Gallery = () => {
    /* -- DEFINE -- *
     * --- PAGE-EDIT-FIELDS ---
     *
     */
    // -- const --
    const query = UrlQuery();
    const [gallerys, setGallerys]= useState([]);
    const [websites, setWebsites]= useState([]);
    const [mobiles, setMobiles]= useState([]);
    const [landings, setLandings]= useState([]);
    // -- page-edit --
    const [sub_value_edit,setSubValueEdit] = useState(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,0));
    const [page,setPage] = useState(Data_Logic.get(Portal_Table.PAGE,0));
    const [sub_value_group,setSubValueGroup] = useState(Sub_Value_Logic.get_test_sub_value_group({count:50,show_value:false}));
    const [edit_mode,setEditMode] = useState(false);
       useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_page_data();
            },[]);
        useEffect(() => {
            Toast_Message.loading(Message.LOADING);
            get_items_data();
            },[]);
         Toast_Message.loading(Message.LOADING);
            async function get_page_data() {
            // -- remote-data-response --
            let option = {get_cache:false,time_limit:10};
            const [response,data] = await Portal_Remote_Page.get(App.get_url(Portal_Url.PAGE_GET),Portal_Page.GALLERY_HOME.title_url,option);
            bind_page(data);
            };
            async function get_items_data() {
            // -- remote-data-response --
            let option = {get_cache:false,time_limit:10};
            let search = Data_Logic.get_search(Portal_Table.GALLERY,{});
            const [response,data] = await Portal_Remote_Page.get_gallery_home_items(App.get_url(Portal_Page.GALLERY_HOME[Portal_Type.ITEMS_URL]),search,option);
            bind_items(data);
            Toast_Message.dismiss();
            }
            async function bind_page(data) {
            // -- page-template --
            setPage(data[Portal_Type.PAGE]);
            // -- page-edit --
            setEditMode(query.get('edit_mode'));
            setSubValueEdit(Sub_Value_Logic.get_sub_value_edit(Portal_Table.PAGE,data[Portal_Type.PAGE].id));
            // -- sub-values --
            bind_sub_values(data[Portal_Type.SUB_VALUE_GROUP]);
            };
            async function bind_sub_values(data_sub_group) {
                // -- sub-values --
                for(const sub_group in data_sub_group){
                    if(data_sub_group[sub_group].type != Sub_Value_Type.ITEMS){
                        sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].value = data_sub_group[sub_group].value;
                    }else{
                        sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+data_sub_group[sub_group].value_id].items = data_sub_group[sub_group].items;
                    }
                }
                Storage.post_sub_value_group(sub_value_edit,data_sub_group);
            };
            async function update_sub_value(sub_value) {
                // -- page-edit-sub-values --
                if(sub_value.type != Sub_Value_Type.ITEMS){
                    setSubValueGroup(sub_value_group => ({
                                ...sub_value_group,
                                [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                                ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                                value: sub_value.value
                                }
                                }));
                }else{
                    setSubValueGroup(sub_value_group => ({
                                ...sub_value_group,
                                [Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id]: {
                                ...sub_value_group[Portal_Type.SUB_VALUE_UNDER_SCORE+sub_value.value_id],
                                items: sub_value.items
                                }
                                }));
                }
            }

            async function bind_pop_up() {
                const handleMessage = (event) => {
                    setPage(event.data);
                };
                window.addEventListener('message',handleMessage);
            };
            async function bind_items(data) {
                // -- gallery --
                setGallerys(data[Portal_Type.GALLERYS]);

                Log.w('11_website',Obj.filter(Portal_Field.TYPE,Title.PRODUCT_APP_TYPE_WEBSITE,data[Portal_Type.GALLERYS]));
                Log.w('11_mobile',Obj.filter(Portal_Field.TYPE,Title.PRODUCT_APP_TYPE_MOBILE,data[Portal_Type.GALLERYS]));

                setWebsites(Obj.filter(Portal_Field.TYPE,Title.PRODUCT_APP_TYPE_WEBSITE,data[Portal_Type.GALLERYS]));
                setMobiles(Obj.filter(Portal_Field.TYPE,Title.PRODUCT_APP_TYPE_MOBILE,data[Portal_Type.GALLERYS]));
                setLandings(Obj.filter(Portal_Field.TYPE,Title.PRODUCT_APP_TYPE_LANDING_PAGE,data[Portal_Type.GALLERYS]));
            }
            return (
                    <>
                    {/* Breadcrumb */}
                    <div className="breadcrumb-bar">
                    <div className="breadcrumb-img">
                    <div className="breadcrumb-left">
                    <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-01.png" alt="img" />
                    </div>
                    </div>
                    <div className="container">
                    <div className="row">
                    <div className="col-md-12 col-12">
                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                    <Link to={all_routes.home}>Home</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                    {sub_value_group.sub_value_1.value}
                    </li>
                    </ol>
                    </nav>
                    <h2 className="breadcrumb-title">
                    {edit_mode?Field_Logic.get_sub_value_edit_link(sub_value_edit,Sub_Value_Type.TEXT,1):""}
                    {sub_value_group.sub_value_1.value}

                    </h2>
                        </div>
                        </div>

                        </div>
                        <div className="breadcrumb-img">
                        <div className="breadcrumb-right">
                        <ImageWithBasePath src="/assets/img/bg/breadcrump-bg-02.png" alt="img" />
                        </div>
                        </div>
                        </div>
                        {/* /Breadcrumb */}
                    {/* Contact Us */}
                    <div className="page-content content">
                        <div className="container">
                        <div className="nav nav-tabs nav-tabs-solid nav-tabs-rounded nav-justified portfolio-tabs owl-theme">

                        <div className="nav-item me-3">
                        <Link className="nav-link text-truncate active" to="#gallery" data-bs-toggle="tab">
                        All
                        </Link>
                        </div>

                        <div className="nav-item me-3">
                        <Link className="nav-link text-truncate" to="#website" data-bs-toggle="tab">
                        Website
                        </Link>
                        </div>
                        <div className="nav-item me-3">
                        <Link className="nav-link text-truncate" to="#mobile" data-bs-toggle="tab">
                        Mobile
                        </Link>
                        </div>
                        <div className="nav-item me-3">
                        <Link className="nav-link text-truncate" to="#landing" data-bs-toggle="tab">
                        Landing Page
                        </Link>
                        </div>
                        </div>

                        <div className="tab-content">
                        <div className="tab-pane show active" id="gallery">
                        <div className="row">
                        {gallerys.map((item) => (
                                    <div className="col-lg-6">
                                    <div className="gallery-widget">
                                    <Link to={"/portfolio/"+item.title_url}>
                                    <ImageWithBasePath className="img-fluid" alt="Image" src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} />
                                    <div className="gallery-overlay">
                                    <h4>{item.title}</h4>
                                    <p>{item.type}</p>
                                    </div>
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                    </div>
                        </div>

                        <div className="tab-pane" id="mobile">
                        <div className="row">
                        {mobiles.map((item) => (
                                    <div className="col-lg-6">
                                    <div className="gallery-widget">
                                    <Link to={"/portfolio/"+item.title_url}>
                                    <ImageWithBasePath className="img-fluid" alt="Image" src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} />
                                    <div className="gallery-overlay">
                                    <h4>{item.title}</h4>
                                    <p>{item.type}</p>
                                    </div>
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                    </div>
                        </div>
                        <div className="tab-pane" id="website">
                        <div className="row">
                        {websites.map((item) => (
                                    <div className="col-lg-6">
                                    <div className="gallery-widget">
                                    <Link to={"/portfolio/"+item.title_url}>
                                    <ImageWithBasePath className="img-fluid" alt="Image" src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} />
                                    <div className="gallery-overlay">
                                    <h4>{item.title}</h4>
                                    <p>{item.type}</p>
                                    </div>
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                    </div>
                        </div>
                        <div className="tab-pane" id="landing">
                        <div className="row">
                        {landings.map((item) => (
                                    <div className="col-lg-6">
                                    <div className="gallery-widget">
                                    <Link to={"/portfolio/"+item.title_url}>
                                    <ImageWithBasePath className="img-fluid" alt="Image" src={Image.get_url(item.image_filename,Image_Format.SQUARE_THUMB)} />
                                    <div className="gallery-overlay">
                                    <h4>{item.title}</h4>
                                    <p>{item.type}</p>
                                    </div>
                                    </Link>
                                    </div>
                                    </div>
                                    ))}
                    </div>
                        </div>
                        </div>
                        </div>
                        </div>
                        <SubValue sub_value_edit={sub_value_edit} edit_mode={edit_mode} update_sub_value={update_sub_value}  />

                        {/* /Contact Us */}
                    </>
                        )
    }
    export default Gallery;
